import { Grid, Paper } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import {
    approveLeaveMsg,
    areYouSureMsg,
    dataNotFoundMsg,
    noInternetMsg,
    rejectLeaveMsg,
    serverMsg,
    statusmsg
} from "../../../config/messageconstant";
import { SalesTeamLeaveJson } from "../../../DynamicFormsJson/MastersJSON/salesTeamLeaveJson";
import { getLeaveSummaryForSalesTeam } from "../../../Slice/LeaveType.slice";
import {
    AddSalesTeamLeaveColumns
} from "../../../tableColumns/table-columns";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../../config/endpoints";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { compose } from "recompose";
import { withRouter } from "../../../components/withRouter";
import { ButtonCompo } from "../../../components/Comman/Button";

class AddSalesTeamLeaveTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewDataList: [],
            viewPopup: false,
            DataToSet: [],
            fromDate: "",
            toDate: "",
            salesTeamId: "",
        };
    }

    componentDidMount() {
        if (this.props.params.id) {
            localStorage.setItem("salesTeamIdForAddLeave", this.props.params.id);
            this.getData(this.props.params.id);
        }
    }

    getData = async (id) => {
        const { getLeaveSummaryForSalesTeam, showLoador, showNotification } = this.props;

        let toDaysDate = dayjs().format("DD-MM-YYYY");

        if (navigator.onLine) {
            showLoador({ loador: true });
            await getLeaveSummaryForSalesTeam({
                salesTeamId: id || this.props.params.id,
                fromDate: toDaysDate,
                toDate: toDaysDate,
            }).then(({ response, success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else if (!response || response.length === 0) {
                    showNotification({ msg: dataNotFoundMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    rowCancel = (rowData) => {
        const { showLoador, showNotification } = this.props;
        const { fromDate, toDate, salesTeamId } = this.state;
        let onSearchData = {
            fromDate: fromDate,
            toDate: toDate,
            salesTeamId: salesTeamId,
        }
        swal({
            title: areYouSureMsg,
            text: rejectLeaveMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                const statusCode = 3;
                await apiGet({
                    url:
                        endpoint.leaveApply +
                        "/update-status?leaveApplyId=" +
                        rowData.id +
                        "&status=" +
                        statusCode,
                }).then(({ data, success }) => {
                    if (!success) {
                        this.props.showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({ msg: statusmsg });
                        this.onSearchData(onSearchData);
                    }
                });
                showLoador({ loador: false });
            }
        });
    };

    rowApply = (rowData) => {
        const { showLoador, showNotification } = this.props;
        const { fromDate, toDate, salesTeamId } = this.state;

        let onSearchData = {
            fromDate: fromDate,
            toDate: toDate,
            salesTeamId: salesTeamId,
        }
        swal({
            title: areYouSureMsg,
            text: approveLeaveMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                const statusCode = 2;
                await apiGet({
                    url:
                        endpoint.leaveApply +
                        "/update-status?leaveApplyId=" +
                        rowData.id +
                        "&status=" +
                        statusCode,
                }).then(({ data, success }) => {
                    if (!success) {
                        this.props.showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({ msg: statusmsg });
                        this.onSearchData(onSearchData);
                    }
                });
                showLoador({ loador: false });
            }
        });
    };

    onSearchData = async (data) => {
        const { getLeaveSummaryForSalesTeam, showLoador, showNotification } =
            this.props;
        if (navigator.onLine) {

            this.setState({
                fromDate: data.fromDate || dayjs().format("DD-MM-YYYY"),
                toDate: data.toDate || dayjs().format("DD-MM-YYYY"),
                salesTeamId: data.salesTeamId || this.props.params.id,
            })

            showLoador({ loador: true });
            await getLeaveSummaryForSalesTeam({
                fromDate: data.fromDate,
                toDate: data.toDate,
                salesTeamId: this.props.params.id,
            }).then(
                ({ success }) => {
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                }
            );
            showLoador({ loador: false });

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    render() {
        const {
            leaveList,
        } = this.props;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <DynamicMainScreen
                        formPath={SalesTeamLeaveJson.formPathForAddLeaveForSalesTeam}
                        screenTitle={SalesTeamLeaveJson.screenTitleForAddSalesTeamLeave}
                        searchList={SalesTeamLeaveJson.searchListForSalesTeamLeave}
                        fieldMeta={SalesTeamLeaveJson.fieldMeta}
                        showPdfDownload={SalesTeamLeaveJson.showPdfDownload}
                        showExcelDownload={false}
                        showExtension={false}
                        pdfFileName={SalesTeamLeaveJson.pdfFileName}
                        excelFileName={SalesTeamLeaveJson.excelFileName}
                        showAddButton={SalesTeamLeaveJson.showAddButton}
                        tableColumnsToFilter={SalesTeamLeaveJson.tableColumnsToFilter}
                        tableColumns={AddSalesTeamLeaveColumns}
                        tableData={leaveList?.leaveSummaryBySalesTeam}
                        getTableData={this.getData}
                        onSearchData={this.onSearchData}
                        apiBaseURL={SalesTeamLeaveJson.apiBaseURL}
                        baseIdColumn={SalesTeamLeaveJson.baseIdColumn}
                        showEditIcon={false}
                        showDeleteIcon={false}
                        showViewButtonInTable={false}
                        showCancel={true}
                        rowCancel={this.rowCancel}
                        showCancelTitle={"Reject Leave"}
                        showApply={true}
                        showApplyTitle={"Approve Leave"}
                        rowApply={this.rowApply}
                        cancelBillConditionName="statusFlag"
                        cancelBillConditionValue="0"
                        credentialConditionName="statusFlag"
                        credentialConditionValue="0"
                        callApi={false}
                        getTableDataById={true}
                        addTitle={"Add Leave"}
                        showBackButtonOnTable={true}

                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    leaveList: state.leaveType,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getLeaveSummaryForSalesTeam,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AddSalesTeamLeaveTable);
